import {Suspense} from 'react';

import {FaqListAll} from '../../components/faq-list-all';

import {type FaqListAllFragment, faqListFromFaqListAllSection} from './query';

type Props = {
	data: FaqListAllFragment;
	fullWidth?: boolean;
	insideToc?: boolean;
};

export const FaqListAllContainer = ({data, fullWidth, insideToc}: Props) => {
	const {fieldOfAreaFilters, initialFaqs} = faqListFromFaqListAllSection(data);

	return (
		<Suspense>
			<FaqListAll
				initialFaqs={initialFaqs}
				fieldOfAreaFilters={fieldOfAreaFilters}
				faqAreaFilters={[]}
				options={{fullWidth, ...data.contentBlockOptions}}
				insideToc={insideToc}
			/>
		</Suspense>
	);
};
